/** Production metadata options and defaults for SongAI Flow (independent of script flow). */

export const EMPTY_SONG_PRODUCTION_METADATA = {
  environment: '',
  background: '',
  country_region: '',
  actors_origin: '',
  ethnicity: '',
  character_age: '',
  character_gender: '',
  character_body_type: '',
  character_height: '',
  character_face_shape: '',
  character_hair_style: '',
  character_hair_color: '',
  character_beard: '',
  character_accessories: '',
  character_jewelry: '',
  character_tattoos: '',
  character_glasses: '',
  clothing_style: '',
  time_of_day: '',
  color_palette: '',
  camera_style: '',
  lens_style: '',
  lighting: '',
  mood: '',
  negative_prompt: '',
  consistency_strength: '',
  character_lock: '',
  seed_lock: '',
  style_reference: '',
  reference_images_notes: '',
  extra_notes: '',
};

export const SONG_ENVIRONMENT_OPTIONS = [
  'Desert', 'Forest', 'Space', 'Mountains', 'Village', 'Medieval',
  'Futuristic', 'Underwater', 'Snow', 'Temple', 'City', 'Cyberpunk',
];

export const SONG_TIME_OF_DAY_OPTIONS = [
  'Morning', 'Golden Hour', 'Night', 'Sunset', 'Rain', 'Storm', 'Fog', 'Winter', 'Summer',
];

export const SONG_COUNTRY_REGION_OPTIONS = [
  'Indian', 'Japanese', 'African', 'European', 'Middle Eastern', 'American', 'Chinese', 'Korean',
];

export const SONG_ETHNICITY_OPTIONS = [
  'Indian', 'Japanese', 'African', 'Arabic', 'European', 'Mixed', 'Custom',
];

export const SONG_CLOTHING_OPTIONS = [
  'Traditional', 'Modern', 'Royal', 'Warrior', 'Casual', 'Formal', 'Fantasy', 'Historical', 'Custom',
];

export const SONG_COLOR_PALETTE_OPTIONS = [
  'Warm', 'Cold', 'Earth Tone', 'Dark', 'Pastel', 'Neon', 'Vintage',
];

export const SONG_CAMERA_STYLE_OPTIONS = [
  'Wide', 'Close Up', 'Drone', 'Handheld', 'Steadicam', 'Tracking', 'Crane', 'POV',
];

export const SONG_LENS_STYLE_OPTIONS = [
  '24mm', '35mm', '50mm', '85mm', 'Macro', 'Telephoto',
];

export const SONG_LIGHTING_OPTIONS = [
  'Soft', 'Hard', 'Natural', 'Studio', 'Moonlight', 'Candlelight', 'Firelight', 'Golden Hour',
];

export const SONG_MOOD_OPTIONS = [
  'Happy', 'Sad', 'Romantic', 'Mystery', 'Epic', 'Emotional', 'Suspense', 'Inspirational', 'Dark', 'Hopeful',
];

export const SONG_CHARACTER_GENDER_OPTIONS = ['Male', 'Female', 'Non-binary', 'Mixed cast'];
export const SONG_CHARACTER_AGE_OPTIONS = ['Child', 'Teen', 'Young adult', 'Adult', 'Elderly'];
export const SONG_CONSISTENCY_OPTIONS = ['Low', 'Medium', 'High', 'Maximum'];

export function formatSongUploadProbe(probe) {
  if (!probe) return null;
  const parts = [];
  if (probe.duration_seconds) {
    const m = Math.floor(probe.duration_seconds / 60);
    const s = Math.round(probe.duration_seconds % 60);
    parts.push(`${m}:${String(s).padStart(2, '0')}`);
  }
  if (probe.sample_rate_hz) parts.push(`${probe.sample_rate_hz} Hz`);
  if (probe.channels) parts.push(probe.channels === 1 ? 'Mono' : `${probe.channels} ch`);
  if (probe.bitrate_kbps) parts.push(`${probe.bitrate_kbps} kbps`);
  return parts.length ? parts.join(' · ') : null;
}
